const config = {
  // baseUrl: 'http://localhost:3001/',
  // baseUrl: "http://192.168.88.22:8888/",
  baseUrl: "https://nachmed.ai/api/",
};

export default config;
